var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactsPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 13.5625H28V10.3125C28 9.86563 27.64 9.5 27.2 9.5H25.6C25.16 9.5 24.8 9.86563 24.8 10.3125V13.5625H21.6C21.16 13.5625 20.8 13.9281 20.8 14.375V16C20.8 16.4469 21.16 16.8125 21.6 16.8125H24.8V20.0625C24.8 20.5094 25.16 20.875 25.6 20.875H27.2C27.64 20.875 28 20.5094 28 20.0625V16.8125H31.2C31.64 16.8125 32 16.4469 32 16V14.375C32 13.9281 31.64 13.5625 31.2 13.5625ZM11.2 16C14.735 16 17.6 13.0902 17.6 9.5C17.6 5.90977 14.735 3 11.2 3C7.665 3 4.8 5.90977 4.8 9.5C4.8 13.0902 7.665 16 11.2 16ZM15.68 17.625H14.845C13.735 18.143 12.5 18.4375 11.2 18.4375C9.9 18.4375 8.67 18.143 7.555 17.625H6.72C3.01 17.625 0 20.682 0 24.45V26.5625C0 27.9082 1.075 29 2.4 29H20C21.325 29 22.4 27.9082 22.4 26.5625V24.45C22.4 20.682 19.39 17.625 15.68 17.625Z",
    fill: "#004FC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsPlus);
export default __webpack_public_path__ + "static/media/contacts-plus.d89d70d5499475e281983c0b87fe0194.svg";
export { ForwardRef as ReactComponent };